"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var loadCoupons = function loadCoupons(payload) {
  return {
    type: 'LOAD_COUPONS',
    payload: payload
  };
};

var loadCouponsSuccess = function loadCouponsSuccess(data, metadata) {
  return {
    type: 'LOAD_COUPONS_SUCCESS',
    payload: {
      data: data,
      metadata: metadata
    }
  };
};

var loadCouponsError = function loadCouponsError(error) {
  return {
    type: 'LOAD_COUPONS_ERROR',
    payload: {
      error: error
    }
  };
};

var loadUsersCoupon = function loadUsersCoupon(payload) {
  return {
    type: 'LOAD_USERS_COUPON',
    payload: payload
  };
};

var loadUsersCouponSuccess = function loadUsersCouponSuccess(data, metadata) {
  return {
    type: 'LOAD_USERS_COUPON_SUCCESS',
    payload: {
      data: data,
      metadata: metadata
    }
  };
};

var loadUsersCouponError = function loadUsersCouponError(error) {
  return {
    type: 'LOAD_USERS_COUPON_ERROR',
    payload: {
      error: error
    }
  };
};

var createCoupon = function createCoupon(payload) {
  return {
    type: 'CREATE_COUPON',
    payload: payload
  };
};

var createCouponSuccess = function createCouponSuccess(data) {
  return {
    type: 'CREATE_COUPON_SUCCESS',
    payload: {
      data: data
    }
  };
};

var createCouponError = function createCouponError(error) {
  return {
    type: 'CREATE_COUPON_ERROR',
    payload: {
      error: error
    }
  };
};

var updateCoupon = function updateCoupon(payload) {
  return {
    type: 'UPDATE_COUPON',
    payload: payload
  };
};

var updateCouponSuccess = function updateCouponSuccess(data) {
  return {
    type: 'UPDATE_COUPON_SUCCESS',
    payload: {
      data: data
    }
  };
};

var updateCouponError = function updateCouponError(error) {
  return {
    type: 'UPDATE_COUPON_ERROR',
    payload: {
      error: error
    }
  };
};

var loadCoupon = function loadCoupon(payload) {
  var _ref = payload || {},
      couponId = _ref.couponId,
      clientId = _ref.clientId;

  return {
    type: 'LOAD_COUPON',
    payload: {
      couponId: couponId,
      clientId: clientId
    }
  };
};

var loadCouponSuccess = function loadCouponSuccess(data) {
  return {
    type: 'LOAD_COUPON_SUCCESS',
    payload: {
      data: data
    }
  };
};

var loadCouponError = function loadCouponError(error) {
  return {
    type: 'LOAD_COUPON_ERROR',
    payload: {
      error: error
    }
  };
};

var isLoading = function isLoading(payload) {
  return {
    type: 'IS_COUPON_LOADING',
    payload: payload
  };
};

var resetCoupons = function resetCoupons() {
  return {
    type: 'RESET_COUPONS'
  };
};

var _default = {
  loadCoupons: loadCoupons,
  loadCouponsSuccess: loadCouponsSuccess,
  loadCouponsError: loadCouponsError,
  loadUsersCoupon: loadUsersCoupon,
  loadUsersCouponSuccess: loadUsersCouponSuccess,
  loadUsersCouponError: loadUsersCouponError,
  createCoupon: createCoupon,
  createCouponSuccess: createCouponSuccess,
  createCouponError: createCouponError,
  updateCoupon: updateCoupon,
  updateCouponSuccess: updateCouponSuccess,
  updateCouponError: updateCouponError,
  loadCoupon: loadCoupon,
  loadCouponSuccess: loadCouponSuccess,
  loadCouponError: loadCouponError,
  isLoading: isLoading,
  resetCoupons: resetCoupons
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map